import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=3689b1d6&"
import script from "./Manager.vue?vue&type=script&lang=js&"
export * from "./Manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports